import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@jem-open/jem-ui";

export interface GeofenceRevertConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  siteName: string;
  onConfirm: () => void;
}

/**
 * Confirms discarding a Roster's custom geofence values when toggling the
 * "Use custom geofence" Switch back off. Used on the per-Site deep config page.
 */
export const GeofenceRevertConfirmDialog: React.FC<
  GeofenceRevertConfirmDialogProps
> = ({ open, onOpenChange, siteName, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Use Site geofence?</DialogTitle>
        <DialogDescription>
          This will discard the Roster&apos;s custom latitude, longitude, and
          radius values, and resume inheriting from <strong>{siteName}</strong>.
          Clock validation will use the Site&apos;s geofence going forward.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="default" onClick={onConfirm}>
          Continue
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default GeofenceRevertConfirmDialog;
